import type { ApiResponse, PageableDto, PageResponse } from '@shared-models';

/**
 * Mapea `ApiResponse<PageableDto>` → `PageResponse<T>` con mapper de filas.
 * Sustituye el bloque copy-paste de ~37 servicios HTTP.
 */
export function mapPageableResponse<TDto, T>(
  response: ApiResponse<PageableDto<TDto>> | ApiResponse<PageableDto>,
  mapper: (item: TDto) => T,
  fallbackSize = 20,
): PageResponse<T> {
  const pageable = response.data;
  const content = (pageable?.content ?? []) as TDto[];
  return {
    items: content.map(mapper),
    page: pageable?.page ?? 0,
    size: pageable?.size ?? fallbackSize,
    totalElements: pageable?.totalElements ?? 0,
    totalPages: pageable?.totalPages ?? 0,
  };
}

/**
 * Extrae solo el array `content` (patrón legacy de history que aún
 * no expone metadatos de página en el front).
 */
export function mapPageableContent<TDto, T = TDto>(
  response: ApiResponse<PageableDto<TDto>> | ApiResponse<PageableDto>,
  mapper?: (item: TDto) => T,
): T[] {
  const content = (response.data?.content ?? []) as TDto[];
  return mapper ? content.map(mapper) : (content as unknown as T[]);
}

/**
 * Mensaje de mutación con fallback.
 */
export function mapMutationMessage(
  response: { message?: string } | null | undefined,
  fallback: string,
): { message: string } {
  return { message: response?.message || fallback };
}
